// extracted by mini-css-extract-plugin
export var acitonButtons = "_g8-0";
export var additionalIcon = "_g8-f";
export var block = "_g8-1";
export var blockContent = "_g8-7";
export var blockDescription = "_g8-8";
export var blockIcon = "_g8-9";
export var blockTitle = "_g8-6";
export var border = "_g8-a";
export var center = "_g8-l";
export var edge = "_g8-b";
export var edgeLabel = "_g8-c";
export var edgePath = "_g8-d";
export var error = "_g8-e";
export var flowchart = "_g8-g";
export var flowchartContent = "_g8-h";
export var highlighted = "_g8-3";
export var hover = "_g8-4";
export var icon = "_g8-i";
export var left = "_g8-m";
export var navButton = "_g8-j";
export var navButtons = "_g8-k";
export var right = "_g8-n";
export var selected = "_g8-2";
export var small = "_g8-5";